import React, { useState, useRef } from "react";
import { FaCaretRight } from "react-icons/fa";
import classNames from "classnames";
import IconText from "../IconText/IconText";
import "./SidebarWidgetOption.scss";
import { withDefaults } from "../../utils/withDefaults";

/**
 * One entry in the component sidebar. A leaf adds a widget of `widgetType`;
 * a branch shows `groupWidgets` in a fly-out on hover.
 */
export interface SidebarWidgetItem {
  friendlyName: string;
  widgetType?: string;
  icon?: React.ReactNode;
  groupWidgets?: SidebarWidgetItem[];
}

export interface SidebarWidgetOptionProps {
  item?: SidebarWidgetItem;
  onClick?: (event: React.MouseEvent, item: SidebarWidgetItem) => void;
}

export default function SidebarWidgetOption(incomingProps: SidebarWidgetOptionProps) {
  const props = withDefaults(incomingProps, sidebarWidgetOptionDefaultProps);

  const { item, onClick } = props;

  const [isVisible, setIsVisible] = useState(false);

  const myRef = useRef<HTMLDivElement | null>(null);

  const renderSidebarOption = (item: SidebarWidgetItem) => {
    return (
      <IconText>
        {item.icon || null}
        <span className="sidebar-widget-name">{item.friendlyName}</span>
        {item.groupWidgets ? (
          <FaCaretRight
            className={classNames("sidebar-icon", "more-options")}
          />
        ) : null}
      </IconText>
    );
  };

  if (item.groupWidgets) {
    return (
      <div
        ref={myRef}
        className={classNames(
          "widget-group",
          isVisible ? "selected-option" : null
        )}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {renderSidebarOption(item)}
        {isVisible ? (
          <div className="widget-group-popup">
            {item.groupWidgets.map((childItem: SidebarWidgetItem, i: number) => {
              return (
                <SidebarWidgetOption
                  key={i}
                  item={childItem}
                  onClick={onClick}
                />
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
  return (
    <div className="single-widget" onClick={(event: React.MouseEvent) => onClick(event, item)}>
      {renderSidebarOption(item)}
    </div>
  );
}

const sidebarWidgetOptionDefaultProps = {
  item: { friendlyName: "" } as SidebarWidgetItem,
  onClick: () => {}
};
